<template>
  <div class="services ">
    <div class="services-head">
      <div class="services-head-container">
        <div class="services-head-container-tabs">
          <div
            class="active-bar"
            :style="{left:(active*(120+12)+14)+'px'}"
          ></div>
          <div
            class="services-head-container-tabs-li keep-hue"
            :class="active === index ? 'active' : ''"
            v-for="(item,index) in columnData"
            :key="index"
            @click="changeColumn(index)"
          >
            <span class="tab-icon">
              <svg-icon :icon="item.iconName"></svg-icon>
            </span>
            <span class="tab-title">{{item.columnName}}</span>
          </div>
        </div>
        <div class="services-head-container-search">
          <el-input
            v-model.trim="searchKeyword"
            class="services-head-container-search-input"
            placeholder=""
            size="small"
            clearable
            @keyup.enter.native="search"
            @clear="clear"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search"
            ></i>
          </el-input>
        </div>
      </div>
    </div>
    <div
      class="services-content"
      v-loading="loading[active]"
      element-loading-background="rgba(0, 0, 0, 0)"
    >
      <ul class="services-content-ul">
        <li
          class="services-content-ul-li"
          v-for="(item, index) in serviceData[spotIndex]"
          @click="handleService(item)"
          :key="index"
        >
          <el-popover
            :placement="getPopOverPosition(index)"
            trigger="hover"
            :append-to-body="false"
            popper-class="service-el-pop"
          >
            <div class="pop-content">
              <ul>
                <li>
                  <span class="label">建设单位：</span>
                  <p class="labelContent oneRowEllipsis">
                    {{item.serviceDepartmentName || '暂无'}}
                  </p>
                </li>
                <li>
                  <span class="label">联系电话：</span>
                  <p class="labelContent oneRowEllipsis">
                    {{item.contactInformation || "暂无"}}
                  </p>
                </li>
              </ul>
              <div class="pop-content-bottom">
                <span
                  class="guide"
                  @click="showApplicationInfo(item)"
                >
                  <svg-icon icon="guide"></svg-icon>
                </span>
                <span
                  class="collection"
                  @click="collectApplication(item,index)"
                >
                  <template v-if="item.collect.trim() !== '1'">
                    <svg-icon
                      icon="collection"
                      class="keep-hue"
                    ></svg-icon>
                  </template>
                  <template v-else>
                    <svg-icon
                      icon="collectioned"
                      class="keep-hue"
                    ></svg-icon>
                  </template>
                </span>
              </div>

            </div>

            <img
              slot="reference"
              class="keep-hue"
              :src="item.servicePicUrl"
            />
          </el-popover>
          <span class="serviceName">{{item.serviceName}}</span>

        </li>
        <NoData
          type="center"
          v-if="serviceData && serviceData.length === 0 && !loading[active]"
        />
      </ul>
      <ul
        class="spots"
        v-if="serviceData.length > 1"
      >
        <li
          v-for="(spotItem, index) in serviceData"
          :class="{ active: spotIndex === index }"
          @click="spotIndex = index"
        ></li>
      </ul>

    </div>
    <el-drawer
      :visible.sync="showApplication"
      :append-to-body="true"
      :show-close="false"
      :withHeader="false"
      custom-class="applicationDrawer"
      size="380px"
    >
      <div class="applicationDrawer-head">
        <span class="applicationDrawer-head-img"><img :src="drawerData.servicePicUrl" /></span>
        <div class="applicationDrawer-head-right">
          <p class="title">{{drawerData.serviceName}}</p>
          <div
            class="handle"
            @click="handleService(drawerData)"
          >
            <el-button
              type="primary"
              round
            >办理服务</el-button>
          </div>
        </div>
      </div>
      <div class="applicationDrawer-info">
        <div class="applicationDrawer-subTitle">
          基本信息
        </div>
        <ul>
          <li v-for="item in infoSetting">
            <span
              class="labelName"
              v-html="item.labelName"
            ></span>
            <template v-if="item.labelVal === 'serviceSource'">
              <span class="labelVal">{{drawerData[item.labelVal] || '应用系统'}}</span>
            </template>
            <template v-else>
              <span class="labelVal">{{drawerData[item.labelVal] || '-'}}</span>
            </template>

          </li>
          <li>
            <span class="labelName">0条评价</span>
            <span class="rate">
              <el-rate
                v-model="drawerData.value || 0"
                disabled
                text-color="#ff9900"
                disabled-void-color="#cccccc"
                score-template="{0}"
              >
              </el-rate>
            </span>
            <span style="flex-grow:1"></span>
            <span class="collectionNum">{{drawerData.collectNum || 0}}人已收藏</span>

            <span>
              <template v-if="drawerData.collect && drawerData.collect.trim() !== '1'">
                <svg-icon
                  icon="collection"
                  class="keep-hue fz16"
                ></svg-icon>
              </template>
              <template v-else>
                <svg-icon
                  icon="collectioned"
                  class="keep-hue fz16"
                ></svg-icon>
              </template>
            </span>
          </li>
        </ul>
      </div>
      <div class="applicationDrawer-bottom">
        <div class="applicationDrawer-bottom-tabs">
          <div
            class="drawer-active-bar"
            :style="{left:(drawerActive*(56+27)+'px')}"
          ></div>
          <div
            class="applicationDrawer-bottom-tabs-li"
            :class="drawerActive === index ? 'active' : ''"
            v-for="(item,index) in drawerBottomModule"
            :key="index"
            @click="changeDrawerColumn(index)"
          >
            {{item.name}}
          </div>
        </div>

        <div
          v-if="drawerActive === 0"
          class="applicationDrawer-bottom-serviceInfo"
        >
          {{drawerData.serviceDesc || drawerData.serviceName}}
        </div>
        <div
          v-if="drawerActive === 1"
          class="applicationDrawer-bottom-serviceInfo"
        >
          功能完善中，敬请期待！
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import { getServiceListV2, getCollectServiceListV2 } from "@/api/service-v2.js";
import { changeCollectService } from "@/api/service.js";
import { mapGetters } from "vuex";
import NoData from "@/views/NewsNew/noData.vue";
import configR from '@/configs.js';
export default {
  name: "ServiceApplication",
  data() {
    return {
      active: 0,
      spotIndex: 0,
      onoff1: true,
      onoff2: true,
      onoff0: true,
      loading: {},
      columnData: [
        {
          columnName: "应用系统",
          iconName: "application",
          columnIcon: `<svg-icon icon="application"></svg-icon>`,
        },
        {
          columnName: "推荐应用",
          iconName: "recApplication",
          columnIcon: `<svg-icon icon="recApplication"></svg-icon>`,
        },
        {
          columnName: "收藏应用",
          iconName: "colApplication",
          columnIcon: `<svg-icon icon="colApplication"></svg-icon>`,
        },
      ],
      contentData: { 0: [], 1: [], 2: [] },
      searchKeyword: "",
      showApplication: false, // 控制应用详情的显示与隐藏
      infoSetting: [
        {
          labelName: "来&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;源:",
          labelVal: "serviceSource",
        },
        {
          labelName: "上线时间:",
          labelVal: "releaseTime",
        },
        {
          labelName: "发布单位:",
          labelVal: "serviceDepartmentName",
        },
        {
          labelName: "联系方式:",
          labelVal: "contactInformation",
        },
      ],
      drawerActive: 0,
      drawerBottomModule: [{ name: "服务简介" }, { name: "用户评价" }],
      drawerData: {},
      computedDrawerWidth: "380px",
    };
  },
  components: {
    NoData,
  },
  computed: {
    ...mapGetters(["userInfo", "request", "token", "serveUrl", "messageUrl"]),
    personalData() {
      return (this.userInfo.accounts && this.userInfo.accounts[0]) || {};
    },
    serviceData() {
      return this.formatCollectionData(
        this.contentData[this.active],
        this.showApplicationNum
      );
    },
  },
  watch: {
    active(value) {
      this.loading[this.active] = true;
      if (!this.onoff1) {
        this.loading[1] = false;
      }
      if (!this.onoff2) {
        this.loading[2] = false;
      }
      if (!this.onoff0) {
        this.loading[0] = false;
      }
      if (value === 0) {
        this.getServiceListV2();
      }
      if (value === 1) {
        this.getServiceListV2("recommand");
      }
      if (value === 2) {
        this.getCollectServiceListV2();
      }
      if(value === 3  && configR.envConfigs.SCHOOL_CODE === 'zhicheng'){
        this.$router.push({name: 'ServiceCenter'});
      }
      // this.serviceData = this.formatCollectionData(this.contentData[value],this.showApplicationNum);
    },
  },
  props: {
    showApplicationNum: {
      type: Number,
      default: 24,
    },
  },
  created() {
    this.$set(this.loading, 0, true);
    this.getServiceListV2();
    const allService = {
          columnName: "全部应用",
          iconName: "skdCollection",
          columnIcon: `<svg-icon icon="skdCollection"></svg-icon>`,
        }
    if(configR.envConfigs.SCHOOL_CODE === 'zhicheng'){
      this.columnData.push(allService);
      
    }
  },

  methods: {
    changeDrawerColumn(index) {
      this.drawerActive = index;
    },
    showApplicationInfo(item) {
      this.showApplication = true;
      this.drawerActive = 0;
      this.drawerData = item || {};
    },
    getPopOverPosition(index) {
      let leftDirection =
        index === this.showApplicationNum - 1 ||
        index === this.showApplicationNum - 2 ||
        index === Math.floor(this.showApplicationNum / 2) - 1 ||
        index === Math.floor(this.showApplicationNum / 2) - 2;
      return leftDirection ? "left" : "right";
    },
    clear() {
      this.search();
    },
    handleClick(value) {},
    changeColumn(index) {
      this.active = index;
      this.spotIndex = 0;
      this.searchKeyword = "";
    },
    formatCollectionData(data, panelDataNum) {
      let collectionService = [];
      if (!data) return [];
      for (let i = 0, len = data.length; i < len; i += panelDataNum) {
        let everyPanelData = data.slice(i, i + panelDataNum);
        collectionService.push(everyPanelData);
      }
      return collectionService;
    },
    search() {
      this.onoff1 = this.onoff2 = this.onoff0 = true;
      this.$set(this.loading, this.active, true);
      if (this.active === 0) {
        this.getServiceListV2();
      } else if (this.active === 1) {
        this.getServiceListV2("recommand");
      } else if (this.active === 2) {
        this.getCollectServiceListV2();
      }else if(this.active === 3 && configR.envConfigs.SCHOOL_CODE === 'zhicheng'){
        this.$router.push({name: 'ServiceCenter'});
      }else {
        this.getServiceListV2();
      }
    },
    handleService(data) {
      if (!data.serviceUrl) {
        this.$message.error("无服务链接!");
      }
      if (window.VBArray) {
        let referLink = document.createElement("a");
        referLink.href = data.serviceUrl;
        if (configR.envConfigs.EXTERNAL_LINKS === "1") {
          referLink.target = "_blank";
        }
        document.body.appendChild(referLink);
        referLink.click();
      } else {
        window.open(data.serviceUrl);
      }
    },
    // 收藏应用
    async collectApplication(item, index) {
      let data = {
        request: this.request,
        serveUrl: this.serveUrl,
        id: item.id,
        collect: item.collect,
      };
      try {
        let res = await changeCollectService(data);
        if (res.code !== 0) {
          this.$message.error(res.message || "操作失败！");
          return;
        }
        if (item.collect && item.collect.trim() === "1") {
          this.$message.success("取消收藏成功!");
        } else {
          this.$message.success("添加收藏成功!");
        }
        // 收藏应用tab, 需要重新请求数据
        if (this.active === 2) {
          await this.getCollectServiceListV2();
        } else {
          this.$set(
            this.serviceData[this.spotIndex][index],
            "collect",
            item.collect.trim() === "1" ? "0" : "1"
          );
        }
        // this.assetsData = res.data || {}
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
    },
    // 获取服务列表 serviceType 4 应用，其他值为服务
    async getServiceListV2(type) {
      let data = {
        request: this.request,
        serveUrl: this.serveUrl,
        params: {
          keyWord: this.searchKeyword,
          type: "4",
          recommend: type === "recommand",
          showPublic: false,
        },
      };
      try {
        let res = await getServiceListV2(data);

        this.$set(this.loading, this.active, false);
        if (type && type === "recommand") {
          this.onoff1 = false;
          this.$set(this.contentData, "1", res.data);
        } else {
          this.onoff0 = false;
          this.$set(this.contentData, "0", res.data);
        }
        if (res.code !== 0) {
          this.$message.error(res.message);
          return;
        }
        this.assetsData = res.data || {};
      } catch (e) {
        this.$message.error("请求服务列表错误!");
        this.$set(this.loading, this.active, false);
        if (type && type === "recommand") {
          this.onoff1 = false;
        } else {
          this.onoff0 = false;
        }
        return;
      }
    },
    // 收藏应用
    async getCollectServiceListV2() {
      let data = {
        request: this.request,
        serveUrl: this.serveUrl,
        params: {
          keyWord: this.searchKeyword,
          type: "4",
          showPublic: false,
        },
      };
      try {
        let res = await getCollectServiceListV2(data);
        this.$set(this.contentData, "2", res.data);
        this.$set(this.loading, this.active, false);
        this.onoff2 = false;
        if (res.code !== 0) {
          this.$message.error(res.message);
          return;
        }
        this.assetsData = res.data || {};
      } catch (e) {
        this.$set(this.loading, this.active, false);
        this.onoff2 = false;
        this.$message.error("请求收藏应用错误!");
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";
ul,
li {
  padding: 0;
}
.services {
  width: 100%;
  background-color: white;
  color: #313131;
  height: 100%;
  &-head {
    width: 100%;
    padding-left: 14px;
    padding-right: 20px;
    &-container {
      border-bottom: 4px solid #f6f6f6;
      display: flex;
      justify-content: space-between;
      &-tabs {
        display: flex;
        position: relative;
        margin-left: -14px;
        &-li {
          display: flex;
          align-items: center;
          padding: 20px 20px;
          color: #313131;
          font-size: 16px;
          cursor: pointer;
          .tab-icon {
            width: 20px;
            height: 20px;
            margin-right: 6px;
            svg {
              width: 100%;
              height: 100%;
            }
          }
          .tab-title {
            line-height: 20px;
          }
        }
      }
      &-search {
        width: 180px;
        padding-top: 16px;
        &-input {
          color: red;
          /deep/ .el-input__inner {
            border-radius: 20px;
            height: 30px;
            line-height: 30px;
          }
          .el-input__icon {
            cursor: pointer;
          }
        }
      }
    }
  }
  &-content {
    width: 100%;
    height: 200px;
    position: relative;
    &-ul {
      display: flex;
      flex-flow: wrap;
      padding: 15px 15px 0;
      justify-content: flex-start;
      margin-top: 20px;
      /*height: 235px;*/
      align-content: flex-start;
      &-li {
        position: relative;
        text-align: center;
        padding-bottom: 30px;
        width: 8.333%;
        font-size: 14px;
        color: #313131;
        align-items: center;
        cursor: pointer;

        @media (max-width: 1719px) {
          width: 12.5%;
        }
        img {
          width: 50px;
          height: 50px;
          display: block;
          margin: 0 auto;
        }
        span.serviceName {
          width: 92%;
          display: inline-block;
          margin-top: 6px;
          text-align: center;
          line-height: 18px;
          padding: 0 4%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        /deep/ .el-popover.service-el-pop {
          padding: 4px 14px 6px 14px !important;
          .pop-content {
            ul {
              li {
                font-size: 12px;
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                margin-top: 12px;
                height: 12px;
                line-height: 12px;
                .label {
                  color: #666666;
                  width: 60px;
                }
                .labelContent {
                  color: #333333;
                  width: calc(100% - 60px);
                }
              }
            }
            .pop-content-bottom {
              margin-top: 6px;
              display: flex;
              flex-direction: row-reverse;
              .collection {
                margin-right: 10px;
              }
              .svg-icon {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
    .spots {
      position: absolute;
      bottom: -40px;
      left: 50%;
      z-index: 15;
      width: 60%;
      padding-left: 0;
      margin-left: -30%;
      text-align: center;
      list-style: none;
      li {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin: 0 5px;
        border: 0;
        border-radius: 50%;
        background: #ededed;
        text-indent: -999px;
        cursor: pointer;
        &.active {
          background: #ccc;
        }
      }
    }
  }
  .active-bar {
    position: absolute;
    bottom: -4px;
    left: 0;
    height: 4px;
    background-color: #f39800;
    z-index: 1;
    transition: 0.4s;
    list-style: none;
    width: 102px;
  }
}
.applicationDrawer {
  &-head {
    display: flex;
    &-img {
      width: 50px;
      height: 50px;
      margin-right: 26px;
      img {
        width: 100%;
      }
    }
    &-right {
      .title {
        font-size: 16px;
        color: #333333;
        font-weight: 400;
        height: 16px;
        line-height: 16px;
      }
      .handle {
        margin-top: 17px;
        /*button.el-button.el-button--primary.is-round {*/
        /*  padding: 8px 12px 7px 14px !important;*/
        /*  border-radius: 16px;*/
        /*  font-size: 16px;*/
        /*  font-weight: 400;*/
        /*  color: #FFFFFF;*/
        /*}*/
      }
    }
  }
  &-info {
    margin-top: 21px;
    .applicationDrawer-subTitle {
      font-size: 14px;
      color: #333333;
      line-height: 14px;
      padding-bottom: 9px;
      border-bottom: 1px solid #e6e6e6;
    }
    ul {
      li {
        color: #333333;
        font-size: 14px;
        margin-top: 16px;
        height: 14px;
        line-height: 14px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        &:nth-child(1) {
          margin-top: 11px;
        }
        .labelName {
          margin-right: 20px;
          width: 65px;
        }
        .rate {
          /deep/ .el-rate {
            .el-rate__icon {
              margin-right: 0px;
              font-size: 20px;
            }
          }
        }
        .collectionNum {
          margin-right: 10px;
        }
      }
    }
  }
  &-bottom {
    margin-top: 19px;
    padding-top: 19px;
    border-top: 1px solid #d3d3d3;
    &-tabs {
      display: flex;
      position: relative;
      color: #333333;
      font-size: 14px;
      padding-bottom: 12px;
      &-li {
        &:nth-child(2) {
          margin-right: 27px;
        }
        &.active {
          font-weight: bold;
        }
        &:hover {
          cursor: pointer;
        }
        transition: 0.4s;
      }
      .drawer-active-bar {
        position: absolute;
        bottom: 0px;
        left: 0;
        height: 4px;
        background-color: $color-primary;
        z-index: 1;
        transition: 0.4s;
        list-style: none;
        width: 57px;
      }
    }
    &-serviceInfo {
      padding-top: 13px;
      font-size: 14px;
      color: #666666;
      line-height: 22px;
    }
  }
}
</style>